import React from 'react';

import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { graphql, navigate } from 'gatsby';
import { useTranslation } from 'react-i18next';

import { ShuttleProviderAccordion } from './shuttle-provider-accordion';
import { ShuttleProviders } from './type';

// ********************************************************************************
export const shuttlePriceMapping = (props: any, locale: string) => {
  return {};
};
type Props = {};
export const ShuttlePrice: React.FC<Props> = () => {
  const { t } = useTranslation();
  // == Render =====================================================================
  return (
    <Box bgcolor="white" py={6}>
      <Container maxWidth="lg">
        <Stack spacing={5}>
          <Stack spacing={3}>
            <Typography variant="h2" color="#3F2B56" fontFamily="Gotham-Medium" fontSize="32px" align="left">
              {t('shuttle_service.shuttle_price.title')}
            </Typography>
            <Typography variant="body1" color="#302F2F" fontSize="18px" textAlign="left" lineHeight="20px" mt={2}>
              {t('shuttle_service.shuttle_price.description')}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{
                maxWidth: '233px',
              }}
              onClick={() => navigate('/#shuttle')}
            >
              {t('shuttle_service.shuttle_price.button')}
            </Button>
          </Stack>
          <ShuttleProviderAccordion provider={ShuttleProviders.LIMOUSINES} name="Limousines" path="/limousines" defaultExpanded />
          <ShuttleProviderAccordion provider={ShuttleProviders.MEXICOACH} name="Mexicoach" path="/mexicouch" />
          {/* <ShuttleProviderAccordion provider={ShuttleProviders.INTERNATIONAL} name="International" path="/international" /> */}
        </Stack>
      </Container>
    </Box>
  );
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment ShuttlePrice on StrapiWidgetrels {
    shuttlePrice {
      key: id
      widgetPosition
    }
  }
`;
